import tw from "twin.macro";

export const Wrapper = tw.div`w-[40px]`;
